import React, { useMemo, useState } from "react";
import { Dropdown } from "antd";
import { FiUser } from "react-icons/fi";
import { useSelector } from "react-redux";
import { resolveUserDisplayName } from "@helpers/permissionCheckboxTree";
import PopMyPermissions from "./PopMyPermissions";

const UserProfileMenu = ({ className = "" }) => {
  const employeeInfo = useSelector((state) => state.user.user.employeeInfo);
  const branchStatus = useSelector((state) => state.user.user.branchStatus);
  const brandInfo = useSelector((state) => state.user.user.brandInfo);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [permissionModalOpen, setPermissionModalOpen] = useState(false);

  const displayName = useMemo(
    () => resolveUserDisplayName({ employeeInfo, branchStatus, brandInfo }),
    [employeeInfo, branchStatus, brandInfo]
  );

  const menuItems = [
    {
      key: "permissions",
      label: (
        <span className="new-header__profile-menu-label">查看帳號權限</span>
      ),
    },
  ];

  return (
    <>
      <div className={`new-header__profile ${className}`.trim()}>
        <Dropdown
          open={dropdownOpen}
          onOpenChange={setDropdownOpen}
          trigger={["click"]}
          placement="bottomRight"
          overlayClassName="new-header__profile-dropdown"
          menu={{
            items: menuItems,
            onClick: ({ key }) => {
              if (key === "permissions") {
                setDropdownOpen(false);
                setPermissionModalOpen(true);
              }
            },
          }}
        >
          <button
            type="button"
            className="new-header__profile-btn"
            aria-label={`個人資料：${displayName}`}
          >
            <span className="new-header__profile-avatar" aria-hidden>
              <FiUser
                className="new-header__profile-icon"
                strokeWidth={1.5}
              />
            </span>
            <span className="new-header__profile-name">{displayName}</span>
          </button>
        </Dropdown>
      </div>
      <PopMyPermissions
        open={permissionModalOpen}
        onClose={() => setPermissionModalOpen(false)}
      />
    </>
  );
};

export default UserProfileMenu;
